import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { NotificationAction, NotificationReducer } from 'types/notification'
import NotificationActions from 'actions/Notification'
import { Dispatch } from 'redux'
import {
    TitleForm,
    MainForm,
    Top,
    TopInputs,
    Subtitle,
    ContainerForm,
    ContentForm,
    LabelGeneralForumPage,
    ValueGeneralInfoForumPage,
    HelpDescription,
    checkboxStyle,
    factorsLabelStyle,
    SubtitleForm,
    horizontalRowLine,
    DescriptionTag,
    ValueGeneralInfoSemiBoldForumPage,
} from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/LondonProtocol/styles'
import { InputLabel } from 'components/InputLabel'
import { Label } from 'components/InputLabel/styles'
import { useForm } from 'react-hook-form'
import NotificationService from 'services/Notification'
import { BackButton, SaveButton, inputRequiredStyle } from '../../styles'
import { InputSelect } from 'components/InputSelect'
import { Toggle } from 'components/Toggle'
import { LabelsForInput } from 'components/LabelsForInputs'
import { TextArea } from 'components/TextArea'
import Checkbox from 'components/InputCheckbox'
import { CustomDatePicker } from 'components/Datepicker'
import { stringToDate } from 'utils/dateUtils'
import { Breadcrumbs, SecondTextBreadcrumbs } from '../../../Header/styles'
import { getCorIncidente, getDamage, getDateTime } from 'utils/damage'
import { WarningModal } from 'components/Modals/WarningModal'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useCallbackPrompt } from 'hooks/useCallbackPrompt'
import { getLabelByValue, setStartedDataV2 } from '../../helper'
import { InfoContent, InfoText, InfoTextTitle } from '../../../NotificationData/styles'
import { VariableAction, VariableReducer } from 'types/variable'
import VariableActions from 'actions/Variable'
import { getVarible } from 'utils/variblesHandler'
import { notificationStatus } from 'constants/notificationStatus'
import { IAuthenticationReducer } from 'types/autentication'
import NumberOrBulletTextArea from 'components/NumberOrBulletTextArea'
import { Beforeunload } from 'react-beforeunload'
import {
    calculateObjectProbabilityOcurrence
} from 'pages/NotificationTreatment/helpers'
import { canEditLondonProtocol } from '../..'
import YellowCircleInterrogation from 'components/Icons/YellowCircleInterrogation'
import DefaultModal from 'components/Modals'
import DataLondonProtocolInfoModal from 'pages/NotifyEvent/components/modals/DataLondonProtocolInfoModal'
import { listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'

/**
 * Formulário principal para edição das informações do diagrama de ishikawa
 */
const FormLondonProtocolV2: React.FC = () => {

    const { id } = useParams()
    const { register, control, watch, handleSubmit, formState: { errors, dirtyFields }, setValue, getValues } = useForm();

    const navigate = useNavigate()
    const [notAllowed, setNotAllowed] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [statusIsArchivedOrFinished, setStatusIsArchivedOrFinished] = useState(false)
    const [manualDirty, setManualDirty] = useState(false)
    const [notificationStatusState, setNotificationStatusState] = useState('')
    const [typesOfDiagnosis, setTypesOfDiagnosis] = useState([]);
    const [sentinelEvent, setSentinelEvent] = useState([]);
    const [neverEvents, setNeverEvents] = useState([]);
    const [omsClassifications, setOmsClassifications] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)
    const notificationDispatch: Dispatch<NotificationAction> = useDispatch<Dispatch<NotificationAction>>()
    const notification = useMemo(() => notificationSelector?.notificationById, [notificationSelector?.notificationById])
    const protocoloLondon = useMemo(() => notificationSelector?.londonProtocol, [notificationSelector?.londonProtocol])
    const protocoloNotificationFactors = useMemo(() => {
        const keys = Object.keys(notificationSelector?.factors || {});
        let response: Record<string, any[]> = {};
        keys.forEach(k => {
            response[k] = notificationSelector?.factors?.[k]?.filter(
                f => f?.u_category_factors_version === notificationSelector?.notificationById?.u_version?.value
            ) || [];
        });
        return response;
    }, [notificationSelector?.factors, notificationSelector?.londonProtocol]);

    const londonVaribles = useMemo(() => notificationSelector?.londonVaribles, [notificationSelector?.londonVaribles])
    const chronologicalReportValue: string = watch('chronological_report') || ''

    const variableSelector: VariableReducer = useSelector(
        (state: RootReducerState) => state.variableReducers
    )
    const variableDispatch: Dispatch<VariableAction> =
        useDispatch<Dispatch<VariableAction>>()

    const auth: IAuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const currentUser = useMemo(() => {
        return auth.dataJwt
    }, [auth])

    const isSameLocation = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notificationSelector.notificationById?.location_incident?.value).length > 0
    }, [currentUser, notificationSelector.notificationById])

    const isSameSector = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notificationSelector.notificationById?.location_incident?.value)[0]?.sectors.filter((i) => i.sys_id === notificationSelector.notificationById?.incident_sector?.value).length > 0
    }, [currentUser, notificationSelector.notificationById])

    const loggedInUserIsResponsible = useMemo(() => {
        return currentUser?.sys_id && currentUser?.sys_id ===
            notificationSelector.notificationById?.u_assigned_to?.value
    }, [currentUser, notificationSelector.notificationById])

    useEffect(() => {
        if (canEditLondonProtocol({ loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState })
            .includes(currentUser?.profile) && !statusIsArchivedOrFinished) {
            setNotAllowed(false)
        } else {
            setNotAllowed(true)
        }
    }, [loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState, statusIsArchivedOrFinished])
    //set data
    useEffect(() => {
        if (protocoloLondon) {
            setStartedDataV2({ setValue, data: protocoloLondon })
        }

    }, [protocoloLondon])

    useEffect(() => {
        if (notificationSelector?.notificationById?.u_state) {
            setNotificationStatusState(
                notificationSelector?.notificationById?.u_state.display_value
            )
        }
    }, [notificationSelector.notificationById])

    useEffect(() => {
        if (notificationStatusState) {
            const allowed = [notificationStatus[4].label, notificationStatus[5].label]
            const satus = allowed.includes(notificationStatusState)
            setStatusIsArchivedOrFinished(satus)
        }
    }, [notificationStatusState])

    useEffect(() => {
        VariableActions.getAllVariables(variableDispatch)
    }, [])
    //FETCH SELECTORs
    useEffect(() => {
        NotificationActions.getNotificationLondonVaribles(notificationDispatch);
        NotificationActions.getNotificationFactors(notificationDispatch);

        NotificationActions.getTypesOfDiagnosis(notificationDispatch);

        NotificationActions.getNotificationById(notificationDispatch, id)
        NotificationActions.getLondonProtocolByNotificationId(notificationDispatch, id)
    }, [])

    useEffect(() => {
        if (variableSelector.variablesList) {
            const varible = getVarible(
                variableSelector.variablesList,
                'containerType',
                'container'
            )
            if (varible?.children) {
                const omsChoices = getVarible(
                    varible?.children,
                    'name',
                    'u_oms_classification'
                )

                setOmsClassifications(omsChoices?.choices)
            }
        }
    }, [variableSelector])

    useEffect(() => {
        if (notificationSelector.typesOfDiagnosis) {
            const typesOfDiagnosisFlat = notificationSelector.typesOfDiagnosis[0]?.result.flat()
            let typesOfDiagnosis = typesOfDiagnosisFlat?.map((item, index) => ({
                label: item.description,
                value: item.sys_id
            })).sort((o1, o2) => o1.label?.localeCompare(o2.label));
            setTypesOfDiagnosis(typesOfDiagnosis)
        }
    }, [notificationSelector.typesOfDiagnosis])

    useEffect(() => {
        if (notificationSelector.sentinelEvent) {
            const flat = notificationSelector.sentinelEvent
            const customSentinel = flat?.map((item, index) => ({
                label: item.description,
                value: item.sys_id
            })).sort((o1, o2) => o1.label?.localeCompare(o2.label))
            setSentinelEvent(customSentinel.slice(14, 15)
                .concat(customSentinel.slice(0, 14)
                    .concat(customSentinel.slice(15))))

        }
    }, [notificationSelector.sentinelEvent])


    useEffect(() => {
        if (notificationSelector.neverEvents) {
            const flat = notificationSelector.neverEvents;
            const neverEventss = flat?.map((item, index) => ({
                label: item.label,
                value: item.id
            }))

            setNeverEvents(neverEventss)
        }
    }, [notificationSelector.neverEvents])

    const getTreatmentNumber = () => {
        if (notificationSelector?.notificationById) {
            if (notificationSelector?.notificationById.document_type?.value === 'atendimento') {
                if (protocoloLondon?.u_patient_care_number) {
                    return protocoloLondon?.u_patient_care_number;
                }
                return notificationSelector?.notificationById?.document_number?.value
            }
        }
    }

    const handleSubmitForm = (data) => {
        setIsSaving(true)

        const neverEventsSelected = neverEvents?.filter(e => e.value === data.u_never_events)
            .map(e => ({
                display_value: e.label,
                value: e.value
            }));
        notificationSelector.notificationById.u_never_events = neverEventsSelected[0];
        const LondonProtocolSN = {
            ...data,
            ...(protocoloLondon?.sys_id ? { sys_id: protocoloLondon?.sys_id } : {}),
            hospital_incident: id,
            u_version: 'v2',
        }

        NotificationService.saveLondonProtocol(LondonProtocolSN, notificationSelector.notificationById).then((response: any) => {
            let notification = notificationSelector.notificationById
            let notificationProcessRequiredStepsRules = calculateObjectProbabilityOcurrence(notification)
            notificationProcessRequiredStepsRules.currentStepSelected = 3
            NotificationActions.defineObjectNotificationProcessRequiredStepsRules(notificationDispatch, notificationProcessRequiredStepsRules)
            navigate(`/notificacoes/${id}`, { state: { currentStep: 3, messageSuccess: 'Protocolo de Londres salvo com sucesso!' } })
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            setIsSaving(false)
        })
    }

    const backToLondonProtocol = useCallback((e: any) => {
        navigate(`/notificacoes/${id}`, { state: { currentStep: 3 } })
    }, [])

    const isDirty = !!Object.keys(dirtyFields).length || manualDirty
    const [showPrompt, confirmNavigation, cancelNavigation] =
        useCallbackPrompt(isDirty && !isSaving)

    const organizationalConsequences = useMemo(() => {
        const organizationalConsequences = londonVaribles?.organizational_consequences.slice(5, 6)
            .concat(londonVaribles?.organizational_consequences.slice(0, 5)
                .concat(londonVaribles?.organizational_consequences.slice(6)))
        return organizationalConsequences
    }, [londonVaribles?.organizational_consequences])

    const onChangeHelper = () => {
        setManualDirty(true)
    }


    const getSentinelEvent = useMemo(() => {
        if(notificationSelector?.sentinelEvent){
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const sentinelEventValue = notificationSelector.notificationById?.u_sentinel_event_jci?.value;
            const [sentinelEvent] = notificationSelector?.sentinelEvent?.filter(se => se?.u_version === notificationVersion)
                                                        .filter(se => se?.sys_id == sentinelEventValue)
            return sentinelEvent?.description || "-";
        }
        
        return "-";
    }, [id])


    const getNeverEvent = useMemo(() => {
        if (notificationSelector?.neverEvents) {
            const notificationVersion = notification?.u_version?.value || process.env.REACT_APP_NOTIFICATION_VERSION
            const neverEventsReference = notificationSelector.notificationById?.u_never_events_reference?.value;
            const [neverEvent] = notificationSelector?.neverEvents?.filter(se => se?.u_version === notificationVersion)
                                                                    .filter(se => se?.sys_id == neverEventsReference)
            return neverEvent?.u_description || "-";
        }
        return "-";
    }, [id])
    

    const onlyProfilecanInputNSPOpinion = useMemo(() => {
        return [listOfRoles.admin, listOfRoles.location_qa].includes(currentUser?.profile)
    },[currentUser])

    return (
        <>
            {isDirty && (
                <Beforeunload onBeforeunload={(event) => 'Você fez edições que não forma salvas.'} />
            )}
            <WarningModal
                icon={
                    <AiOutlineExclamationCircle
                        size={50}
                        className="text-yellow"
                    />
                }
                customStyle={{
                    titleStyle: 'text-yellow'
                }}
                title="Edição não salva"
                subTitle="Você fez edições que não foram salvas. Se sair, você perderá as edições."
                leftButtonAction={confirmNavigation as () => void}
                rightButtonAction={cancelNavigation as () => void}
                isOpen={showPrompt as boolean}
                handleCloseModal={cancelNavigation as () => void}
                leftButtonText="Sair"
                rightButtonText="Continuar edição"
            />
            <DefaultModal
                isOpen={showModal}
                handleCloseModal={() => {
                    setShowModal(false)
                }}
                children={<DataLondonProtocolInfoModal
                    close={() => {
                        setShowModal(false)
                    }}
                />}
            />


            <ContainerForm data-testid="test-step3-from">
                <MainForm onSubmit={handleSubmit(handleSubmitForm)}>
                    <div className='flex items-baseline mt-8 justify-between'>
                        <Breadcrumbs>
                            <Link className="mr-1 cursor-pointer" to="/notificacoes">
                                Gestão das notificações
                            </Link>
                            {' > '}
                            <SecondTextBreadcrumbs className="mr-1 cursor-pointer" onClick={backToLondonProtocol}>
                                Notificações
                            </SecondTextBreadcrumbs>
                            {' > '}
                            <SecondTextBreadcrumbs>Protocolo de Londres</SecondTextBreadcrumbs>
                        </Breadcrumbs>
                        <TopInputs>
                            <BackButton type='button' onClick={backToLondonProtocol}>Voltar</BackButton>
                            <SaveButton type='submit' disabled={!isDirty} className={!isDirty ? 'bg-disabled' : ''}>Salvar</SaveButton>
                        </TopInputs>
                    </div>
                    <fieldset disabled={notAllowed}>
                        <div className='overflow-y-auto'>
                            <Top>
                                <div>
                                    <TitleForm data-testid='notifications'> Preencher Protocolo de Londres </TitleForm>
                                    <SubtitleForm>Identifique os detalhes que levaram o incidente acontecer, e preencha abaixo as informações:</SubtitleForm>
                                </div>

                            </Top>
                            <hr />
                            <ContentForm>
                                <div className='flex flex-col col-span-2'>
                                    <div className='h-[696px] px-8 mt-1 mb-1'>
                                        <div id="general-info">
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Informações gerais da notificação
                                            </Subtitle>
                                            <div className="grid grid-cols-4 gap-4">
                                                <InfoContent>
                                                    <InfoTextTitle>Chave da notificação</InfoTextTitle>
                                                    <InfoText $bold>
                                                        {notification?.number?.display_value}
                                                    </InfoText>

                                                    <div className="mt-2">
                                                        <span
                                                            className={`chip-incidente incidente-${getCorIncidente(
                                                                getDamage(
                                                                    notification?.damage_level?.value
                                                                )?.value
                                                            )}`}
                                                        >
                                                            {`${getDamage(
                                                                notification?.damage_level?.value
                                                            )?.label
                                                                }`}
                                                        </span>
                                                    </div>

                                                </InfoContent>
                                                <div>
                                                    <LabelGeneralForumPage>Data da notificação</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{
                                                        getDateTime(notification?.sys_created_on?.value)
                                                    }</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Setor notificante</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.reporter_sector?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div className='ml-[265px] w-full'>
                                                    <LabelGeneralForumPage>Notificante</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.reporter_name?.display_value || 'Anônimo'}</ValueGeneralInfoForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-4 gap-4 w-full">
                                                <div>
                                                    <Label></Label>
                                                    <span></span>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Data da ocorrência</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.date_incident?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Setor notificado</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.incident_sector?.display_value}</ValueGeneralInfoForumPage>
                                                </div>

                                                <div className='ml-[265px] w-full'>
                                                    <LabelGeneralForumPage>Turno que o evento ocorreu</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.shift_incident?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-4 gap-4 mt-7">
                                                <div>
                                                    <LabelGeneralForumPage>Iniciais do nome do paciente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage style={{ wordBreak: 'break-all' }}>
                                                        {notification?.patient_initials?.display_value}
                                                    </ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Data de nascimento</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>{notification?.patient_date_of_birth?.display_value}</ValueGeneralInfoForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Prontuário</LabelGeneralForumPage>
                                                    <ValueGeneralInfoForumPage>
                                                        {notification?.document_type?.value !== 'atendimento' && notification?.document_number?.value ? (notification?.document_number?.value) : ("-")}
                                                    </ValueGeneralInfoForumPage>
                                                </div>

                                                <div>
                                                    {getTreatmentNumber() ?
                                                        (<>
                                                            <LabelGeneralForumPage>Número do atendimento</LabelGeneralForumPage>
                                                            <ValueGeneralInfoForumPage>
                                                                {getTreatmentNumber()}
                                                            </ValueGeneralInfoForumPage>
                                                        </>) : (<>
                                                            {notificationSelector?.notificationById &&
                                                                notificationSelector?.notificationById.document_type?.value === 'prontuario' ?
                                                                (<>
                                                                    <ValueGeneralInfoForumPage>
                                                                        <Label>Número do atendimento | {protocoloLondon?.u_patient_care_number} </Label>
                                                                        <InputLabel
                                                                            errorStyle='-bottom-[18px]'
                                                                            className={`w-[363px] max-w-[552px]`}
                                                                            name="u_patient_care_number"
                                                                            register={register}
                                                                            required={true}
                                                                            placeholder="Digite aqui"
                                                                            maxLength={80}
                                                                            error={{
                                                                                message: errors.u_patient_care_number
                                                                                    ? 'Preenchimento obrigatório.'
                                                                                    : ''
                                                                            }} />
                                                                    </ValueGeneralInfoForumPage>
                                                                </>) : (<>

                                                                </>)}
                                                        </>)}
                                                </div>

                                            </div>
                                        </div>

                                        <div className='my-6'>
                                            <Label>Convênio</Label>
                                            <HelpDescription>
                                                Informar também se for Particular ou SUS no campo abaixo
                                            </HelpDescription>
                                            <InputLabel
                                                required={true}
                                                errorStyle='-bottom-[18px]'
                                                name="patients_health_insurance"
                                                register={register}
                                                className={`max-w-[552px] ${errors.patients_health_insurance ? inputRequiredStyle : ''}`}
                                                placeholder="Digite aqui"
                                                maxLength={80}
                                                error={{
                                                    message: errors.patients_health_insurance
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''
                                                }}
                                            />
                                        </div>

                                        <div className='mt-6'>
                                            <div className={`${!errors.date_of_patient_admission ? 'mb-6' : ''} w-[195px]`}>
                                                <CustomDatePicker
                                                    disabled={notAllowed}
                                                    name="date_of_patient_admission"
                                                    control={control}
                                                    required={true}
                                                    label="Data da internação do paciente"
                                                    placeholderData="Selecione"
                                                    dateValue={stringToDate(
                                                        notification?.date_of_patient_admission?.display_value,
                                                        'dd/MM/yyyy',
                                                        '/'
                                                    )}
                                                    maxDate={new Date()}
                                                    isError={!!errors.date_of_patient_admission}
                                                />
                                                <span className='text-errorText text-xs'>{errors.date_of_patient_admission
                                                    ? 'Preenchimento obrigatório.'
                                                    : ''}</span>
                                            </div>
                                            <div>
                                                <InputSelect
                                                    searchPlaceHolder="Buscar"
                                                    shouldHaveSearch={true}
                                                    errorTextStyle='-bottom-[18px]'
                                                    required={true}
                                                    label="Diagnóstico do paciente"
                                                    styleContainer={`w-[660px] `}
                                                    styleBoxOptions="w-[660px] top-[55px]"
                                                    name="types_of_diagnosis"
                                                    control={control}
                                                    data={typesOfDiagnosis}
                                                    placeholder="Selecione"
                                                    errorStyle={`${errors.types_of_diagnosis ? inputRequiredStyle : ''
                                                        }`}
                                                />

                                            </div>
                                        </div>

                                        <div className="w-full mt-6">
                                            <TextArea
                                                label='Time de investigação do evento'
                                                subLabel='Informar também o cargo dos colaboradores envolvidos'
                                                required={true}
                                                name="event_investigation_team"
                                                register={register}
                                                className={`max-w-[1120px] h-[70px] ${errors.event_investigation_team && inputRequiredStyle}`}
                                                placeholder="Digite aqui"
                                                rows={8}
                                                error={{
                                                    message: errors.event_investigation_team
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''
                                                }}
                                            />
                                        </div>
                                        <hr className={horizontalRowLine} />
                                        <div id="incident_analysis">
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Análise do incidente
                                            </Subtitle>
                                            <div className='mt-6'>
                                                <div>
                                                    <LabelGeneralForumPage>Título do incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_title?.display_value ? notification?.incident_title?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>

                                            </div>
                                            <div className='w-[1024px] mt-6'>
                                                <div>
                                                    <LabelGeneralForumPage>Descrição do incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_description?.display_value ? notification?.incident_description?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>

                                            </div>
                                            <div className='w-[1024px] mt-6'>
                                                <div>
                                                    <LabelGeneralForumPage>Ação corretiva imediata</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.immediate_corrective_action?.display_value ? notification?.immediate_corrective_action?.display_value : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                            </div>

                                        </div>

                                        <hr className={horizontalRowLine} />

                                        <div id="incident-detail" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Detalhes do incidente
                                            </Subtitle>
                                            <div className="grid grid-cols-2 gap-2 mt-4">
                                                <div>
                                                    <LabelGeneralForumPage>Tipo de Incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${notification?.incident_type?.display_value}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div>
                                                    <LabelGeneralForumPage>Classificação do Incidente</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{`${getDamage(notification?.damage_level?.value)?.label}`}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-2 gap-2 mt-6">
                                                <div>
                                                    <Label>Probabilidade de ocorrência do incidente</Label>
                                                    <Toggle
                                                        isError={!!errors?.probability}
                                                        required={true}
                                                        register={register}
                                                        name="probability"
                                                        itens={londonVaribles?.probability?.sort((a, b) => a.index - b.index)?.map(
                                                            (t) => ({
                                                                title: t.label,
                                                                value: t.value
                                                            })
                                                        )}
                                                        defaultCheckedValue="Nunca ocorreu"
                                                    />
                                                    <span className='text-errorText text-xs'>{errors.probability
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''}</span>
                                                </div>
                                                <div>
                                                    <Label>Análise de tolerabilidade</Label>
                                                    <Toggle
                                                        isError={!!errors?.tolerability_analysis}
                                                        required={true}
                                                        register={register}
                                                        name="tolerability_analysis"
                                                        itens={londonVaribles?.tolerability_analysis?.sort((a, b) => a.index - b.index)?.map(
                                                            (t) => ({
                                                                title: t.label,
                                                                value: t.value
                                                            })
                                                        )}
                                                        defaultCheckedValue="Tolerável"
                                                    />
                                                    <span className='text-errorText text-xs'>{errors.tolerability_analysis
                                                        ? 'Preenchimento obrigatório.'
                                                        : ''}</span>
                                                </div>

                                            </div>
                                        </div>

                                        <hr className={horizontalRowLine} />

                                        <div id="extra-information" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'>
                                                Informações extras
                                            </Subtitle>
                                            <div className="grid grid-cols-1 gap-1 mt-4">
                                                <div>
                                                    <div>
                                                        <LabelGeneralForumPage>Classificação do incidente de acordo com a OMS - Organização Mundial de Saúde</LabelGeneralForumPage>
                                                        <ValueGeneralInfoSemiBoldForumPage>{`${notification?.u_oms_classification?.display_value ? getLabelByValue(omsClassifications, 'value', notification?.u_oms_classification?.value) : ("-")}`}</ValueGeneralInfoSemiBoldForumPage>
                                                    </div>
                                                </div>
                                                <div className='mt-4'>
                                                    <LabelGeneralForumPage>Never Events - ANVISA</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{getNeverEvent}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div className='mt-4'>
                                                    <LabelGeneralForumPage>Evento Sentinela - JCI</LabelGeneralForumPage>
                                                    <ValueGeneralInfoSemiBoldForumPage>{getSentinelEvent}</ValueGeneralInfoSemiBoldForumPage>
                                                </div>
                                                <div className='mt-4'>                                                    
                                                    <InputSelect
                                                        searchPlaceHolder="Buscar"
                                                        errorTextStyle='-bottom-[18px]'
                                                        required={false}
                                                        label="Consequências organizacionais"
                                                        styleContainer="w-[1120px]"
                                                        styleBoxOptions="w-[1120px] top-[55px]"
                                                        name="organizational_consequences"
                                                        control={control}
                                                        data={organizationalConsequences}
                                                        placeholder="Selecione"
                                                        errorStyle={`${errors.organizational_consequences ? inputRequiredStyle : ''}`}
                                                    />

                                                    <div className="w-full mt-6">
                                                        <LabelsForInput
                                                            title="Relato cronológico do evento"
                                                            subtitle=""
                                                        />

                                                        <NumberOrBulletTextArea
                                                            maxLength={50000}
                                                            inputLength={50000 - chronologicalReportValue.length}
                                                            required={true}
                                                            onChangeHelper={onChangeHelper}
                                                            isDotOrNumber="number"
                                                            setValue={setValue}
                                                            getValues={getValues}
                                                            register={register}
                                                            defaultValue={notification?.chronological_report?.display_value}
                                                            name="chronological_report"
                                                            textAreaStyle={`max-w-[1120px] h-[260px] ${errors.chronological_report && inputRequiredStyle}`}
                                                            placeholder="1. Digite aqui"
                                                            rows={8}
                                                            error={{
                                                                message: errors.chronological_report
                                                                    ? 'Preenchimento obrigatório.'
                                                                    : ''
                                                            }}
                                                        />

                                                    </div>
                                                    <div className="w-full mt-6">
                                                        <LabelsForInput
                                                            title="Pontos fortes da assistência prestada e problemas no manejo dos cuidados"
                                                            subtitle="Resuma brevemente as principais conclusões da investigação e da assistência prestada, indicando tanto a boa prática quanto os problemas identificados."
                                                        />
                                                        <TextArea
                                                            name="u_strengths_of_the_care_provided_and_problems_in_managing_care"
                                                            register={register}
                                                            className={`h-[80px]`}
                                                            placeholder="Digite aqui"
                                                            rows={8}
                                                        />

                                                    </div>
                                                    <div className="w-full mt-6">
                                                        <div className="flex text-right items-center pb-1">
                                                            <LabelsForInput title="Fonte de dados e métodos" />
                                                            <div className="flex items-center ml-1 cursor-pointer" onClick={() => setShowModal(true)}>
                                                                <YellowCircleInterrogation />
                                                                <span className="ml-2 text-sm underline font-semibold text-blueTheme">
                                                                    Saiba mais
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <TextArea
                                                            name="u_data_source_and_methods"
                                                            register={register}
                                                            className={`h-[80px]`}
                                                            placeholder="Digite aqui"
                                                            rows={8}
                                                        />

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <hr className={horizontalRowLine} />
                                        <div id="contributing-factors" className='my-6'>
                                            <Subtitle className='text-blueTheme font-bold'> Fatores contribuintes </Subtitle>
                                            <div id='patient-factors'>
                                                <div className='my-5'>
                                                    <Label>Fatores do paciente</Label>
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.patient_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="patient_factors"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_patient_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='individual-factors ' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores individuais (colaboradores)" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.individual_factors_people || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="individual_factors_people"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_individual_factors_people_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='task-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Tarefas" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.task_factors_and_technology || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="task_factors_and_technology"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_task_factors_and_technology_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='team-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores da equipe" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.team_factors_teams || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="team_factors_teams"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_team_factors_teams_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='work-environment' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores do ambiente de trabalho" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.work_environment_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="work_environment_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_work_environment_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='task-technology-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Tecnologia e sistemas eletrônicos de informação" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.technology_and_electronic_information_systems || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="u_technology_and_electronic_information_systems"
                                                        onChange={() => { }}
                                                    />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_technology_and_electronic_information_systems"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='organizational-managerial-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores organizacionais, gerenciais e culturais" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.organizational_and_managerial_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="organizational_and_managerial_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_organizational_and_managerial_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='institutional-context-factors' className='mt-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Fatores de contexto Institucional" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.institutional_context_factors || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="institutional_context_factors"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_institutional_context_factors_description"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>

                                            <div id='patient-support-factors' className='mt-6 mb-6'>
                                                <div className='my-3'>
                                                    <LabelsForInput title="Apoio a pacientes, familiares e equipe" />
                                                    <Checkbox
                                                        control={control}
                                                        register={register}
                                                        data={protocoloNotificationFactors?.support_for_patients_families_and_staff || []}
                                                        checkBoxStyle={`${checkboxStyle} ml-[1px]`}
                                                        labelStyle={factorsLabelStyle}
                                                        name="u_support_for_patients_families_and_staff"
                                                        onChange={() => { }} />
                                                </div>
                                                <div>
                                                    <DescriptionTag>Descrição</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_support_for_patients_families_and_staff"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>
                                            <hr className={horizontalRowLine} />

                                            { 
                                            onlyProfilecanInputNSPOpinion && <div id='nsp-factors' className='pb-8 mt-6'>
                                                <Label>Parecer do NSP</Label>
                                                <HelpDescription>
                                                    Campo destinado à Qualidade da Unidade (opcional)
                                                </HelpDescription>
                                                <Toggle
                                                    required={false}
                                                    register={register}
                                                    name="u_nsp_opinion"
                                                    itens={protocoloNotificationFactors?.nsp_opinion?.map(
                                                        (t) => ({
                                                            title: t.label,
                                                            value: t.value
                                                        })
                                                    )}
                                                    defaultCheckedValue="Tolerável"
                                                />
                                                <div className='mt-4'>
                                                    <DescriptionTag>Comentário</DescriptionTag>
                                                    <TextArea
                                                        name="u_description_nsp_opinion"
                                                        register={register}
                                                        className={`h-[80px]`}
                                                        placeholder="Digite aqui"
                                                        rows={8}
                                                    />
                                                </div>
                                            </div>
                                            }                                         

                                        </div>

                                    </div>
                                </div>

                            </ContentForm>
                        </div>
                    </fieldset>
                </MainForm>
            </ContainerForm>
        </>
    )
}

export { FormLondonProtocolV2 }
